import { CommentData } from "../interface/comment";

export interface CommentReplyData extends CommentData {
  replies: CommentReplyData[];
}

// Organize comments and replies by post
export function organizeCommentsByPost(
  comments: CommentData[],
  postId: number
): CommentReplyData[] {
  // Filter by post_id
  const filteredComments = comments.filter(
    (comment) => comment.post_id === postId
  );

  // Create a map to store comments with replies
  const commentsMap = new Map<number, CommentReplyData>();
  const organizedComments: CommentReplyData[] = [];

  // Initialize comment map with top-level comments and replies array
  filteredComments.forEach((comment) => {
    const commentWithReplies: CommentReplyData = { ...comment, replies: [] };
    commentsMap.set(comment.id, commentWithReplies);

    if (comment.parent_id === null) {
      organizedComments.push(commentWithReplies);
    }
  });

  // Associate replies with their parent comments
  filteredComments.forEach((reply) => {
    if (reply.parent_id !== null) {
      const parentComment = commentsMap.get(reply.parent_id);
      if (parentComment) {
        parentComment.replies.push(commentsMap.get(reply.id)!);
      }
    }
  });

  // Sort comments and replies by commented_at
  organizedComments.forEach((comment) => {
    comment.replies.sort(
      (a, b) =>
        new Date(a.commented_at).getTime() - new Date(b.commented_at).getTime()
    );
  });

  organizedComments.sort(
    (a, b) =>
      new Date(a.commented_at).getTime() - new Date(b.commented_at).getTime()
  );

  return organizedComments;
}

// Get a comment or reply by ID
export function getCommentOrReply(
  comments: CommentData[],
  id: number
): CommentData | undefined {
  return comments.find((comment) => comment.id === id);
}

// Add a new comment or reply to the list
export function addCommentOrReply(
  comments: CommentData[],
  newComment: CommentData
): CommentData[] {
  if (
    !newComment.post_id ||
    !newComment.author_id ||
    !newComment.commented_at
  ) {
    throw new Error(
      "Missing required fields: post_id, author_id, or commented_at"
    );
  }

  comments.push(newComment);
  return comments;
}
